import React, {Component} from 'react'
import PropTypes from 'prop-types'
import SearchField from '../../../home/components/filters/SearchField'
import FilterDateRangeV2 from '../../../home/components/filters/FilterDateRangeV2'
import FilterProductType from './FilterProductType'
import BatchesPartner from "./BatchesPartner"
import BatchesPartnerSew from "./BatchesPartnerSew"
import SelectFilterOptions from '../../../shared/SelectFilterOptions'
import NumberFilterOptions from '../../../shared/NumberFilterOptions'
import {BATCH_PRIORITY, OPTIONS_OVERTIME, MERGE_STATUS, TAGS} from "./ListOptions.json"
import { Select } from 'antd'

class BatchProductionStatusPageFilters extends Component {
    constructor(props) {
        super(props)
        const {typeOverTime} = props

        this.state = {
            printed_overtime: '',
            transferred_overtime: '',
            sewing_overtime: '',
            [typeOverTime]: 'yn'
        }
    }

    _handleChangeField = (field, value) => {
        const {handleChangeInput} = this.props
        if(field==='brand'|| field === 'batch_overtime' || field === 'tags') {
            handleChangeInput(field,value)
        }else{
            handleChangeInput(field, value.trim())
        }
    }

    _handleChangeName = (field, value) => {
        const {handleChangeInput} = this.props
        const newValues = value.trim().split(/,|\r|\n|\t|\r\n|\s|,\s|,/)

        if (typeof handleChangeInput === 'function') {
            handleChangeInput(field, [...new Set(newValues)])
        }
    }

    _handleChangeDate = (field, value) => {
        const {handleChangeDate} = this.props
        const cloneFilter = Object.assign({}, this.props.filters)

        cloneFilter[field] = value

        if (value.from === '' || value.to === '') {
            delete cloneFilter[field]
        }

        handleChangeDate(cloneFilter)
    }

    _handleChangeOverTime = (field, value) => {
        this.setState({
            [field]: value
        }, () => {
            const {handleChangeDate} = this.props
            const cloneFilter = Object.assign({}, this.props.filters)

            value !== 'days' && delete cloneFilter[field]

            switch (value) {
                case 'y':
                    cloneFilter[field] = {from: 0}
                    break
                case 'yy':
                    cloneFilter[field] = {from: 0, phase_status: 'completed'}
                    break
                case 'yn':
                    cloneFilter[field] = {from: 0, phase_status: 'not_completed'}
                    break
                case 'n':
                    cloneFilter[field] = {to: 0}
                    break
                default:
            }

            if (value !== 'days') {
                handleChangeDate(cloneFilter)
            } else if (typeof cloneFilter[field] === "object") {
                delete cloneFilter[field]['phase_status']
                delete cloneFilter[field]['from']
            }
        })
    }

    _handleChangeOverDayPrinted = (e) => {
        const {name, value} = e.target
        const {handleChangeDate} = this.props
        const cloneFilter = Object.assign({}, this.props.filters)

        cloneFilter['printed_overtime'] = {...cloneFilter['printed_overtime'], [name]: parseInt(value, 0)}

        if (value === null || value === '') {
            delete cloneFilter['printed_overtime'][name]
        }

        if (!cloneFilter['printed_overtime'].hasOwnProperty('from') && !cloneFilter['printed_overtime'].hasOwnProperty('to')) {
            delete cloneFilter['printed_overtime']
        }

        handleChangeDate(cloneFilter)
    }

    _handleChangeOverDayTransformed = (e) => {
        const {name, value} = e.target
        const {handleChangeDate} = this.props
        const cloneFilter = Object.assign({}, this.props.filters)

        cloneFilter['transferred_overtime'] = {...cloneFilter['transferred_overtime'], [name]: parseInt(value, 0)}

        if (value === null || value === '') {
            delete cloneFilter['transferred_overtime'][name]
        }

        if (!cloneFilter['transferred_overtime'].hasOwnProperty('from') && !cloneFilter['transferred_overtime'].hasOwnProperty('to')) {
            delete cloneFilter['transferred_overtime']
        }

        handleChangeDate(cloneFilter)
    }

    _handleChangeOverDaySewing = (e) => {
        const {name, value} = e.target
        const {handleChangeDate} = this.props
        const cloneFilter = Object.assign({}, this.props.filters)

        cloneFilter['sewing_overtime'] = {...cloneFilter['sewing_overtime'], [name]: parseInt(value, 0)}

        if (value === null || value === '') {
            delete cloneFilter['sewing_overtime'][name]
        }

        if (!cloneFilter['sewing_overtime'].hasOwnProperty('from') && !cloneFilter['sewing_overtime'].hasOwnProperty('to')) {
            delete cloneFilter['sewing_overtime']
        }

        handleChangeDate(cloneFilter)
    }

    getOptionOverTime = (start, end) => {
        const Options = []
        for (let i = start; i <= end; i++) {
            if(i !==0){
                const Option = {
                    name: i,
                    value: i,
                }
                Options.push(Option)
            }
        }
        return Options
    }

    render() {
        const {printed_overtime, transferred_overtime, sewing_overtime, cut_lasers} = this.state
        const {filters, onChangeProductType, showPartner, status, merge_file_status, listBrand} = this.props
        const {level, batch_overtime, tags} = filters
        const Option = Select.Option
        const disableNoBrand = !!filters.brand && filters.brand.length>0 && !filters.brand.includes('no brand')
        const disableOptionBrand = !!filters.brand && filters.brand.length>0 && filters.brand.includes('no brand')

        return (
            <div className='BatchesPageContainer'>
                <div className='row align-items-starts'>
                    <div className='FilterLevel col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={level}
                            style={{width: '100%'}}
                            listOptions={BATCH_PRIORITY}
                            field="level" label="Độ ưu tiên"
                            handleChange={this._handleChangeField}
                        />
                    </div>

                    <div className='FilterNameBatch col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Tên lô</label>
                        <SearchField
                            field='name'
                            placeholder='Tìm kiếm theo tên Lô...'
                            onChangeInput={this._handleChangeName}
                        />
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Người tạo lô</label>
                        <SearchField
                            field='user_create'
                            placeholder='Tìm kiếm theo người tạo ...'
                            onChangeInput={this._handleChangeField}
                        />
                    </div>

                    <div className='col-12 col-xl-4 mb-3'>
                        <label className="font-weight-bold d-block">Loại sản phẩm</label>
                        <FilterProductType
                            productTypes={filters.product_types}
                            onChangeProductType={onChangeProductType}
                        />
                    </div>


                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Ngày tạo lô</label>
                        <FilterDateRangeV2 field='created_at' onDatesChange={this._handleChangeDate}/>
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Ngày cắt</label>
                        <FilterDateRangeV2 field='cut_at' onDatesChange={this._handleChangeDate} showTime/>
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Ngày khắc</label>
                        <FilterDateRangeV2 field='engraved_at' onDatesChange={this._handleChangeDate} showTime/>
                    </div>

                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Ngày hoàn thiện</label>
                        <FilterDateRangeV2 field='improved_at' onDatesChange={this._handleChangeDate} showTime/>
                    </div>

                    {/* <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Ngày ép</label>
                        <FilterDateRangeV2 field='transferred_at' onDatesChange={this._handleChangeDate}/>
                    </div> */}

                    <div className='col-12 col-xl-2 mb-3'>
                        <label className="font-weight-bold d-block">Ngày in lô</label>
                        <FilterDateRangeV2 field='printed_at' onDatesChange={this._handleChangeDate}/>
                    </div>
                    {/* {
                        showPartner && (
                            <div className='col-12 col-xl-2 mb-3'>
                                <label className="font-weight-bold d-block">Ngày giao may</label>
                                <FilterDateRangeV2 field='sewing_at' onDatesChange={this._handleChangeDate}/>
                            </div>
                        )
                    }

                    {
                        showPartner && (
                            <div className='col-12 col-xl-2 mb-3'>
                                <label className="font-weight-bold d-block">Ngày nhận may</label>
                                <FilterDateRangeV2 field='receive_sew_at' onDatesChange={this._handleChangeDate}/>
                            </div>
                        )
                    } */}

                    {showPartner && <BatchesPartner onChangePartner={this._handleChangeField}/>}

                    {/* {showPartner && <BatchesPartnerSew onChangePartner={this._handleChangeField}/>} */}

                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={merge_file_status}
                            listOptions={MERGE_STATUS}
                            style={{width: '100%'}}
                            field="merge_file_status" label="Trạng thái gộp"
                            handleChange={this._handleChangeField}
                        />
                    </div>


                    <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={printed_overtime}
                            listOptions={OPTIONS_OVERTIME}
                            style={{width: '100%'}}
                            field="printed_overtime" label="Thời gian quá hạn In"
                            handleChange={this._handleChangeOverTime}
                        />
                    </div>

                    {
                        printed_overtime === 'days' && (
                            <div className='col-12 col-xl-auto mb-3'>
                                <NumberFilterOptions
                                    field='from'
                                    placeholder="từ"
                                    defaultValue={filters.printed_overtime !== undefined ? filters.printed_overtime.from : ''}
                                    handleChange={this._handleChangeOverDayPrinted}
                                />
                            </div>
                        )
                    }

                    {
                        printed_overtime === 'days' && (
                            <div className='col-12 col-xl-auto mb-3'>
                                <NumberFilterOptions
                                    field='to'
                                    placeholder="đến"
                                    defaultValue={filters.printed_overtime !== undefined ? filters.printed_overtime.to : ''}
                                    handleChange={this._handleChangeOverDayPrinted}
                                />
                            </div>
                        )
                    }

                    {/* <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={transferred_overtime}
                            listOptions={OPTIONS_OVERTIME}
                            style={{width: '100%'}}
                            field="transferred_overtime"
                            label="Thời gian quá hạn Ép"
                            handleChange={this._handleChangeOverTime}
                        />
                    </div> */}

                    {
                        transferred_overtime === 'days' && (
                            <div className='col-12 col-xl-auto mb-3'>
                                <NumberFilterOptions
                                    field='from'
                                    placeholder="từ"
                                    defaultValue={filters.transferred_overtime !== undefined ? filters.transferred_overtime.from : ''}
                                    handleChange={this._handleChangeOverDayTransformed}
                                />
                            </div>
                        )
                    }

                    {
                        transferred_overtime === 'days' && (
                            <div className='col-12 col-xl-auto mb-3'>
                                <NumberFilterOptions
                                    field='to'
                                    placeholder="đến"
                                    defaultValue={filters.transferred_overtime !== undefined ? filters.transferred_overtime.to : ''}
                                    handleChange={this._handleChangeOverDayTransformed}/>
                            </div>
                        )
                    }

                    {/* <div className='col-12 col-xl-2 mb-3'>
                        <SelectFilterOptions
                            defaultValue={sewing_overtime}
                            listOptions={OPTIONS_OVERTIME}
                            style={{width: '100%'}}
                            field="sewing_overtime"
                            label="Thời gian quá hạn May"
                            handleChange={this._handleChangeOverTime}
                        />
                    </div> */}

                    {
                        sewing_overtime === 'days' && (
                            <div className='col-12 col-xl-auto mb-3'>
                                <NumberFilterOptions
                                    field='from'
                                    placeholder="từ"
                                    defaultValue={filters.sewing_overtime !== undefined ? filters.sewing_overtime.from : ''}
                                    handleChange={this._handleChangeOverDaySewing}
                                />
                            </div>
                        )
                    }

                    {
                        sewing_overtime === 'days' && (
                            <div className='col-12 col-xl-auto mb-3'>
                                <NumberFilterOptions
                                    field='to'
                                    placeholder="đến"
                                    defaultValue={filters.sewing_overtime !== undefined ? filters.sewing_overtime.to : ''}
                                    handleChange={this._handleChangeOverDaySewing}
                                />
                            </div>
                        )
                    }

                    <div className='col-12 col-xl-2 mb-3 filterBrand RequestSelect'>
                        <div className="SelectFilterOption">
                            <label htmlFor="request_update" className="d-block w-100 font-weight-bold">Brand</label>
                            <Select
                                name='brand'
                                className='brand'
                                mode={'multiple'}
                                onChange={( value ) => this._handleChangeField( 'brand', value )}
                                value={filters.brand}
                                allowClear
                                placeholder='Chọn brand name'
                                style={{ width: '100%', maxWidth:'460px' }}
                            >
                                <Option disabled={disableNoBrand} value='no brand'> No brand</Option>
                                {listBrand.length && listBrand.map((i, index) => (
                                    <Option disabled={disableOptionBrand} value={i.value} key={index}>{i.label}</Option>
                                ))
                                }
                            </Select>
                        </div>
                    </div>

                    <div className='col-12 col-xl-2 mb-3 filterBrand RequestSelect'>
                    <SelectFilterOptions
                            defaultValue={batch_overtime}
                            listOptions={this.getOptionOverTime(-6,6)}
                            style={{width: '100%'}}
                            field="batch_overtime" label="Thời gian item quá hạn"
                            handleChange={this._handleChangeField}
                            mode='multiple'
                            showArrow
                            allowClear
                            placeholder='Chọn thời gian item quá hạn'
                        />
                    </div>

                    <div className='col-12 col-xl-2 mb-3 filterBrand RequestSelect'>
                    <SelectFilterOptions
                            defaultValue={[]}
                            listOptions={TAGS}
                            style={{width: '100%'}}
                            field="tags" label="Tag"
                            handleChange={this._handleChangeField}
                            mode='tags'
                            showArrow
                            allowClear
                            placeholder='Chọn tag'
                            isMultiple={true}
                        />
                    </div>
                </div>
            </div>
        )
    }

}

BatchProductionStatusPageFilters.defaultProps = {
    showPartner: true
}

BatchProductionStatusPageFilters.propTypes = {
    showPartner: PropTypes.bool,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    handleChangeInput: PropTypes.func.isRequired,
    onChangeProductType: PropTypes.func.isRequired
}

export default BatchProductionStatusPageFilters